<template>
  <div>
    <div class="wrapper">
      <expandable-item
        v-for="(item, firstIndex) in itemsWithoutLast"
        :key="firstIndex"
        :items="itemsWithoutLast"
        :item="item"
        :level="0"
      >
        <template #action="attrs">
          <slot name="action" v-bind="attrs"></slot>
        </template>
      </expandable-item>
    </div>

    <expandable-item
      is-last
      :level="0"
      :items="items"
      :item="lastItem"
      :opened-icon="openedIcon"
      :closed-icon="closedIcon"
    >
      <template #action="attrs">
        <slot name="action" v-bind="attrs"></slot>
      </template>
    </expandable-item>
  </div>
</template>

<script>
import ExpandableItem from './private/ExpandableItem.vue'

/**
 * @displayName Tree View
 */
export default {
  name: 'ZTreeView2',
  components: {
    ExpandableItem,
  },
  props: {
    /**
     * Itens a serem consumidos pelo componente
     *
     * @typedef  {title:string,value:any,open:boolean,children:array}
     */
    items: {
      type: Array,
      required: true,
      default: () => [],
    },

    openedIcon: {
      type: String,
      default: '$arrow_down',
    },

    closedIcon: {
      type: String,
      default: '$keyboard_arrow_right_rounded',
    },
  },
  computed: {
    itemsWithoutLast() {
      return this.items.slice(0, this.items.length - 1)
    },

    lastItem() {
      return this.items.slice(-1)[0]
    },
    titleLength() {
      let arr = []
      for (const item of this.items) {
        arr.push(item.title.length)
      }

      let bigger = Math.max(...arr)

      return `min-content ${bigger + 25}ch 1fr`
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;

  &::before {
    content: '';
    height: calc(100% + 35px);
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }
}
</style>
